import React from "react";
import Loading from "../../../ui-components/loading/loading";
import { ReactComponent as Location } from "../../../images/location-blue.svg";
import { ReactComponent as Warning } from "../../../images/warning-orange.svg";
import { ReactComponent as Group } from "../../../images/gate_code.svg";
import { ReactComponent as Home } from "../../../images/Home-yellow.svg";
import { ReactComponent as VerifiedTick } from "../../../images/Verified Green Tick.svg";
import { cn } from "services/common/className";

export enum AddressmanagerSummaryTileTypes {
    totalLocations = "totalLocations",
    limitedAccess = "limitedAccess",
    gateCodeRequired = "gateCodeRequired",
    residential = "residential",
    fullyVerifiedAddress = "fullyVerifiedAddress"
}
interface AddressmanagerSummaryTileProps {
    type: AddressmanagerSummaryTileTypes;
    isLoading: boolean;
    title: string;
    value: string | number;
    clicked?: boolean;
    onClick?: () => void;
    onClear?: () => void;
}

const getTileIcon = (type: AddressmanagerSummaryTileTypes) => {
    if (type === "totalLocations") return <Location />;
    else if (type === "limitedAccess") return <Warning />;
    else if (type === "gateCodeRequired") return <Group />;
    else if (type === "residential") return <Home />;
    else if (type === "fullyVerifiedAddress") return <VerifiedTick />;
    else return "";
}

export const AddressmanagerSummaryTile: React.FC<AddressmanagerSummaryTileProps> = (props) => {
    const cnTile = cn("xgs-addressmanager-summary__tile");

    return (<div className={cnTile({
        enabled: props.clicked,
        clickable: true,
    })}>
        <div className={`icon-container --type-${props.type}`}>
            {getTileIcon(props.type)}
        </div>
        <div className="content">
            {props.isLoading ?
                <Loading isLoading={true} /> :
                <div className="value">{props.value}</div>
            }
            <div className="action-container">
                <div className="title">{props.title}</div>
                {props.title !== "Total Locations" && (props.clicked ?
                    <div className="apply" onClick={props.onClear}>Clear</div> :
                    <div className="apply" onClick={props.onClick}>Apply</div>
                )}
            </div>
        </div>
    </div>
    )
};